<script src="node_modules/highcharts-broken-axis/index.js"></script>
<script src="http://code.highcharts.com/maps/modules/exporting.js"></script>
<script src="http://code.highcharts.com/maps/modules/boost.js"></script>

<div id="container" class="grafiek" [chart]="chart"
    [ngClass]="{'big': setPeriodGraphSizeToBig == true, 'small': setPeriodGraphSizeToBig != true}">
</div>